import { useEffect } from 'react';
import { useSocket } from '../contexts/SocketProvider';

/**
 * Subscribe to a Socket.IO server event while the socket is connected.
 * Handler is removed on unmount or when dependencies change.
 */
export const useSocketEvent = (eventName, handler, deps = []) => {
  const { socket } = useSocket();

  useEffect(() => {
    if (!socket || !eventName || !handler) {
      return undefined;
    }

    socket.on(eventName, handler);
    return () => {
      socket.off(eventName, handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- caller controls handler deps
  }, [socket, eventName, handler, ...deps]);
};

export default useSocketEvent;
